// extracted by mini-css-extract-plugin
module.exports = {"navIcon":"_3-L4p","rc-tabs-bar":"QXgWP","rc-tabs-tab-active":"ZykR6","input-suffix":"p4leP","nav-item":"xQcZW"};